import AppFooter from "../AppFooter";

const ContactUs = () => {
    return (
        <>
            <div className="grid">
                <div className="col-12">
                    <div className="card docs">
                        <h4>Contact Us :</h4>
                        <h6>Bangalore office :</h6>
                        <p>
                            Desiri Naturals Pvt Ltd.,#3,
                            N P Complex, Opp Shree Madduramma Temple,
                            Nagarabhavi Circle,
                            Bangalore
                            India
                            +91 86607 78953

                        </p>

                        <h6>Mysore Office :</h6>
                        <p>
                        Desiri Naturals Pvt Ltd.,
                        Shop # 10,
                        J S S College Doctor’s Quarters Complex,
                        Adjacent to Karnataka Bank,
                        Ramanuja Road, Mysore 570004
                        Phone : 91 81058 63435
                        </p>

                        <h6>Manufacturing Plant :</h6>
                        Desiri Naturals Pvt Ltd.
                        Behind Govt School
                        Adaganahalli Village,
                        K R Nagar, Mysore
                        99458 11771

                        <p>
                        Desiri Naturals Pvt Ltd.,
                        Rajanapalya Village,
                        Magadi Taluk,
                        Ramanagara,
                        Karnataka
                        99458 11771
                        </p>
                    </div>
                </div>
            </div>
            <AppFooter />
        </>
    );
};

export default ContactUs;
